'use client';
import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { value: '100+', label: 'Customers Served' },
  { value: '50+', label: 'Product Types' },
  { value: '600K+', label: 'Virgin Plastic Pieces Replaced' },
  { value: '24hr', label: 'Quote Response' },
];

export default function StatsBar() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-primary py-8 lg:py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <p
          className={`text-center text-white/60 text-xs font-semibold uppercase tracking-widest mb-6 transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          Packaging that respects the planet
        </p>
        <div
          className={`grid grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          {stats?.map((stat, i) => (
            <div
              key={stat?.label}
              className="text-center"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div
                className="text-3xl md:text-4xl font-black text-white"
                style={{ fontFamily: 'Fraunces, serif' }}
              >
                {stat?.value}
              </div>
              <div className="text-white/70 text-sm font-normal mt-1">{stat?.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
